import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type PlanFeatureDetail = {
    featureId: string
    featureKey: string
    description: string
    unit: string
    planFeatures: (unknown | null)[]
}

export type PlanFeature = {
    planId: string
    featureId: string
    limitType: string
    limitInt: number
    limitDecimal: number
    resetPeriod: string
    pooledScope: string
    rollover: string
    gracePercent: number
    throttleAfter: number
    feature: PlanFeatureDetail
}

export type Plan = {
    planId: string
    planSku: string
    name: string
    description: string
    billingInterval: string
    isAddon: boolean
    createdAt: string
    updatedAt: string
    features: PlanFeature[]
    externalId: string
}

export const getPlan = (id: string): Promise<Plan> => {
    return api.get(`/v2/plans/${id}`)
}

export const getPlanQueryOptions = (planId: string) => {
    return queryOptions({
        queryKey: ['plans', planId],
        queryFn: () => getPlan(planId),
    })
}

type UsePlanOptions = {
    planId: string
    queryConfig?: QueryConfig<typeof getPlan>
}

export const usePlan = ({ planId, queryConfig }: UsePlanOptions) => {
    return useQuery({
        ...getPlanQueryOptions(planId),
        ...queryConfig,
    })
}


